import React from 'react';
import { FaTwitter, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import './footer.css';
import { useLocation } from 'react-router-dom';


const Footer = ({ fixed }) => {
  const location = useLocation();
  const { pathname } = location;
  const isHomePage = pathname === '/';
    if (isHomePage){
      fixed = false;
    }
    else {fixed = true};
  
  const handleMailClick = () => {
    window.location.href = 'mailto:hpatadi07@gmail.com';
  };

  return (
    <footer className={`footer ${fixed ? 'fixed' : 'relative'}`}>
      <div className="Company">
        <div className="logo">{/* Add your logo here */}</div>
        <div className="company-info">
          <span className="copyright-icon">&#169;</span>
          <span className="company-name">Oil Harris 2023</span>
        </div>
      </div>

      <div className="social-media">
        <a href="#">
          <FaTwitter /> Twitter
        </a>
        <a href="#">
          <FaLinkedin /> LinkedIn
        </a>
        <a href="#" onClick={handleMailClick}>
          <FaEnvelope /> Mail
        </a>
      </div>

      {isHomePage && (
        <div className="shop-button">
          <button type="button">Shop</button>
        </div>
      )}
    </footer>
  );
};

export default Footer;
